import get from "lodash/get";

const getSectionSlug = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["data", "story", "sections", 0, "slug"], "");
  } else if (pageType === "section-page") {
    return get(state, ["data", "section", "slug"], "");
  }
  return "";
};

const getSectionId = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["data", "story", "sections", 0, "id"], "");
  } else if (pageType === "section-page") {
    return get(state, ["data", "section", "id"], "");
  }
  return "";
};

const getStoryId = (state, pageType) => {
  if (pageType === "story-page") {
    return get(state, ["data", "story", "public-identifier"], get(state, ["data", "story", "id"], ""));
  }
  return "";
};

const getSectionList = (state, pageType) => {
  if (pageType === "story-page") {
    const sections = get(state, ["data", "story", "sections"], []);
    const sectionList = sections.map((item) => item.name);
    return sectionList;
  }

  return [];
};

const getTagList = (state, pageType) => {
  if (pageType === "story-page") {
    const tags = get(state, ["data", "story", "tags"], []);
    const tagList = tags.map((item) => item.name);
    return tagList;
  }

  return [];
};

export const setViewportSizeMapping = (adSlot, viewPortSizeMapping) => {
  const mapping =
    viewPortSizeMapping.length === 1
      ? window.googletag.sizeMapping().addSize(viewPortSizeMapping[0].viewport, viewPortSizeMapping[0].sizes).build()
      : window.googletag
          .sizeMapping()
          .addSize(viewPortSizeMapping?.[0]?.viewport, viewPortSizeMapping?.[0]?.sizes)
          .addSize(viewPortSizeMapping?.[1]?.viewport, viewPortSizeMapping?.[1]?.sizes)
          .build();

  adSlot?.defineSizeMapping(mapping);
};

function refreshSlot(id) {
  window.googletag.cmd.push(function () {
    if (window.googletag.pubadsReady) {
      // detect whether PubAdsService is fully loaded
      const existingSlot = window.googletag
        .pubads()
        .getSlots()
        .filter((item) => id === item.getSlotElementId());

      window.googletag.pubads().refresh(existingSlot);
    }
  });
}

const getEnvironment = (qtState) => {
  return get(qtState, ["config", "ads-config", "environment"], "");
};

export const setTargetingParams = (adSlot, qtState, storySectionSlug, lazyLoadRefreshAdUnit = true) => {
  const pageType = get(qtState, ["pageType"], "");
  const environment = getEnvironment(qtState);
  const sectionSlug = storySectionSlug || getSectionSlug(qtState, pageType);
  const storyId = getStoryId(qtState, pageType);

  adSlot
    .addService(window.googletag.pubads())
    .setTargeting("Page_Type", pageType)
    .setTargeting("environment", environment);

  if (sectionSlug) {
    adSlot.setTargeting("Section_Name", sectionSlug);
  }

  if (storyId) {
    adSlot.setTargeting("Article_ID", storyId);
  }

  if (lazyLoadRefreshAdUnit) {
    adSlot.setTargeting("refresh", "true");
  }
};

export const useDfpSlot = ({
  path,
  size,
  id,
  qtState,
  viewPortSizeMapping,
  storySectionSlug,
  refreshAdUnit,
  outOfPage,
  lazyLoadRefreshAdUnit,
}) => {
  if (refreshAdUnit && window.googletag && window.googletag.apiReady) {
    // check if the API is ready
    refreshSlot(id);
  }

  window?.googletag?.cmd?.push(function () {
    let responsiveAdSlot;

    if (outOfPage) {
      responsiveAdSlot = window.googletag.defineOutOfPageSlot(path, id);
    } else {
      responsiveAdSlot = window.googletag.defineSlot(path, size, id);
    }

    if (responsiveAdSlot) {
      setTargetingParams(responsiveAdSlot, qtState, storySectionSlug, lazyLoadRefreshAdUnit);
      !outOfPage && setViewportSizeMapping(responsiveAdSlot, viewPortSizeMapping);
    }
  });

  window?.googletag?.cmd?.push(function () {
    window.googletag.display(id);
  });
};

export const getAdSlots = ({
  path,
  size,
  id,
  qtState,
  type,
  viewPortSizeMapping,
  storySectionSlug,
  loadAdsSynchronously,
  delayPeriod,
  refreshAdUnit,
  outOfPage,
  lazyLoadRefreshAdUnit,
}) => {
  if (loadAdsSynchronously) {
    useDfpSlot({
      path: path,
      size: size,
      id: id,
      qtState: qtState,
      type: type,
      viewPortSizeMapping: viewPortSizeMapping,
      storySectionSlug,
      refreshAdUnit,
      outOfPage,
      lazyLoadRefreshAdUnit,
    });
  } else {
    setTimeout(() => {
      useDfpSlot({
        path: path,
        size: size,
        id: id,
        qtState: qtState,
        type: type,
        viewPortSizeMapping: viewPortSizeMapping,
        storySectionSlug,
        refreshAdUnit,
        outOfPage,
        lazyLoadRefreshAdUnit,
      });
    }, delayPeriod);
  }
};
